import styled from "styled-components"
import { Icon } from "@xingternal/winery-ui/lib/Icon"

const BenchmarkIcon = styled(Icon).attrs((props) => ({
  size: 10,
  name: "profile-trophy",
  align: "middle",
  color: props.theme.colors.information,
}))``

export default BenchmarkIcon
